import { render, staticRenderFns } from "./giftCode.vue?vue&type=template&id=c0ed6ee8"
import script from "./giftCode.vue?vue&type=script&lang=js"
export * from "./giftCode.vue?vue&type=script&lang=js"
import style0 from "./giftCode.vue?vue&type=style&index=0&id=c0ed6ee8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports